import React from 'react';
import './SocialIcons.css';
import { ReactComponent as Twitter } from '../../assets/icons/twitter.svg';
import { ReactComponent as Linkedin } from '../../assets/icons/linkedin.svg';
import { ReactComponent as Facebook } from '../../assets/icons/facebook.svg';
import { ReactComponent as Envelope } from '../../assets/icons/envelope-open.svg';
import { Anchor } from '../../components';

export const SocialIcons = (props) => {
    return (
        <ul className="social-icons-container" style={props.style}>
            <li>
                <Anchor href="https://twitter.com/cademy__">
                    <Twitter height="22px" fill="var(--cademy-blue)" />
                </Anchor>
            </li>
            <li>
                <Anchor href="https://www.facebook.com/cademy.co.uk">
                    <Facebook height="22px" fill="var(--cademy-blue)" />
                </Anchor>
            </li>
            <li>
                <Anchor href="https://www.linkedin.com/company/cademy-io">
                    <Linkedin height="22px" fill="var(--cademy-blue)" />
                </Anchor>
            </li>
            <li>
                <Anchor href="https://upscri.be/hxh121">
                    <Envelope height="22px" fill="var(--cademy-blue)" />
                </Anchor>
            </li>
        </ul>
    );
};
